import { defineStore } from 'pinia'
import marketReportApi from '@/api/marketreport'
import type { MarketReportSubscriptionAttributes } from 'common'
import { useUserStore } from './user'
import { coreClient } from '@/api/coreclient'

export const useMarketReportStore = defineStore('marketreport', {
  state: () => ({
    activeSubscriptions: [] as MarketReportSubscriptionAttributes[],
    activeReport: null as MarketReportSubscriptionAttributes | null
  }),
  actions: {
    async refreshList() {
      this.activeSubscriptions = await marketReportApi.list()
    },
    async get(id: number) {
      this.activeReport = null
      return marketReportApi.get(id).then((result) => {
        this.activeReport = result
        return result
      })
    },
    async update(report: MarketReportSubscriptionAttributes) {
      const data = await marketReportApi.update(report)
      const existingRecordIndex = this.activeSubscriptions.findIndex((_) => _.id === report.id)
      if (existingRecordIndex > -1 && data) {
        this.activeSubscriptions = [data]
          .concat(this.activeSubscriptions.slice(0, existingRecordIndex))
          .concat(this.activeSubscriptions.slice(existingRecordIndex + 1))
      }
      return data
    },
    async delete(id: number) {
      return marketReportApi.delete(id).then(() => {
        const index = this.activeSubscriptions.findIndex((_) => _.id === id)
        this.activeSubscriptions.splice(index, 1)
        useUserStore().deleteRecentReport(id.toString())
      })
    },
    async create(report: MarketReportSubscriptionAttributes) {
      const client = await coreClient()
      return await client.marketReport
        .create(report)
        .then((response) => {
          if (response.data !== null) {
            this.activeSubscriptions = [response.data].concat(this.activeSubscriptions)
            return response.data
          }
          return null
        })
        .catch((e) => {
          console.error(e)
          return null
        })
    }
  }
})
